import React from 'react';

import type CK from '~/types/contentking';

import AdminAccountDestructConfirmationModal from '~/components/app/AdminAccountDestructConfirmationModal';

import {
	useCleanCustomerAccountMutation,
} from './AdminCleanCustomerAccountModal.gql';

import useAccountName from '~/hooks/useAccountName';



type Props = {
	accountId: CK.AccountId | null,
};

const AdminCleanCustomerAccountModal: React.FC<Props> = (props) => {
	const {
		accountId,
	} = props;

	const accountName = useAccountName(accountId);

	const [cleanCustomerAccount] = useCleanCustomerAccountMutation();

	const handleSubmit = React.useCallback(
		async () => {
			if (accountId === null) {
				return;
			}

			await cleanCustomerAccount({
				variables: {
					accountId,
				},
			});
		},
		[
			accountId,
			cleanCustomerAccount,
		],
	);

	return (
		<AdminAccountDestructConfirmationModal
			accountId={accountId}
			confirmButton="Clean Account"
			description={(
				<p>
					Clean account <strong>{accountName} ({accountId})</strong>.
				</p>
			)}
			onConfirmation={handleSubmit}
			titleAction="Clean"
			titleObject="Account"
		/>
	);
};



export default AdminCleanCustomerAccountModal;
